import globalFilter from '../../../tools/globalFilter'

export default function (state, payload) {
  let selectedBerufe = payload.selectedItems
  return {
    ...state,
    selectedBerufe: selectedBerufe,
  }
}
